import React from "react";
import { Link } from "react-router";
import { Container, Nav } from "react-bootstrap";
import styled from "styled-components";
import { Capacitor } from "@capacitor/core";
import { useTheme } from "components/shared/ThemeProvider";
import androidDownloadIcon from "../../assets/images/android_download.png";
import iosDownloadIcon from "../../assets/images/ios_download.png";

const StyledFooter = styled.footer`
    background-color: ${(props) =>
        props.$isDarkMode ? "#404040" : "#f8f9fa"} !important;
    border-top: 1px solid ${(props) => (props.$isDarkMode ? "#666" : "#dee2e6")};
`;

const DownloadSection = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;

    @media (max-width: 768px) {
        justify-content: center;
        margin-bottom: 20px;
    }
`;

const DownloadText = styled.span`
    font-size: 0.9rem;
    color: ${(props) => (props.$isDarkMode ? "#ccc" : "#6c757d")};
    margin-right: 10px;
    font-weight: 500;

    @media (max-width: 768px) {
        display: block;
        text-align: center;
        margin-right: 0;
        margin-bottom: 10px;
    }
`;

const DownloadIcon = styled.img`
    height: 40px;
    width: auto;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px;

    &:hover {
        transform: translateY(-2px);
        opacity: 0.8;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    @media (max-width: 768px) {
        height: 35px;
    }
`;

const Footer = () => {
    const { isDarkMode } = useTheme();

    return (
        <StyledFooter className="py-4 mt-auto" $isDarkMode={isDarkMode}>
            <Container>
                {/* Download Section */}
                {!Capacitor.isNativePlatform() && (
                    <div className="row mb-3">
                        <div className="col-12 text-center">
                            <DownloadSection>
                                <DownloadText $isDarkMode={isDarkMode}>
                                    Download our app:
                                </DownloadText>
                                <DownloadIcon
                                    src={androidDownloadIcon}
                                    alt="Download for Android"
                                    onClick={() => {
                                        // Add your Google Play Store link here
                                        window.open(
                                            "https://play.google.com/store",
                                            "_blank"
                                        );
                                    }}
                                />
                                <DownloadIcon
                                    src={iosDownloadIcon}
                                    alt="Download for iOS"
                                    onClick={() => {
                                        // Add your App Store link here
                                        window.open(
                                            "https://apps.apple.com/app-store",
                                            "_blank"
                                        );
                                    }}
                                />
                            </DownloadSection>
                        </div>
                    </div>
                )}
                {/* Footer Links */}
                <div className="row">
                    <div className="col-md-6">
                        <p className="text-muted mb-0">
                            &copy; {new Date().getFullYear()} Wishliz. All
                            rights reserved.
                        </p>
                    </div>
                    <div className="col-md-6 text-md-end">
                        <Nav.Link
                            href="#"
                            as={Link}
                            to="/help"
                            className="text-muted d-inline me-3"
                        >
                            Help
                        </Nav.Link>
                        <Nav.Link
                            href="#"
                            as={Link}
                            to="/legal/privacy-policy"
                            className="text-muted d-inline"
                        >
                            Privacy Policy
                        </Nav.Link>
                    </div>
                </div>
            </Container>
        </StyledFooter>
    );
};

export default Footer;
